import styled from 'styled-components';
import colors from '../../../assets/styles/colors';

export const ClientDataSearchColumn = styled.div`
  display: grid;
  grid-gap: 10px;
  margin-top: 30px;
`;

export const ClientDataSearchError = styled.div`
    display: ${prop => prop.visible ? 'inline' : 'none'};
    color:${colors.bgDanger};
    font-size: 12px;
    line-height: 14px;
    margin: 5px 8px;
    transition: ease-in-out .2s;
`;

export const StepFourFooterRightSide = styled.div`
  display: flex;
`;